import Box from "@mui/material/Box";

import { ROUTINE_SLOTS, type RoutineDay } from "~/lib/routine";

/**
 * A day at a glance: one dot per dose, morning then evening, filled once it is in.
 *
 * Decoration only — every caller puts the same information in an accessible label,
 * because two coloured dots say nothing to a screen reader.
 */
export function DosePips({
  doses,
  size = 8,
  inverted = false,
}: {
  doses: RoutineDay | undefined;
  size?: number;
  /** On a filled (selected) cell, where the slot colours would not read. */
  inverted?: boolean;
}) {
  return (
    <Box aria-hidden="true" sx={{ display: "flex", gap: `${size / 2}px` }}>
      {ROUTINE_SLOTS.map((slot) => {
        const taken = doses?.[slot] !== undefined;
        const ink = inverted ? "primary.contrastText" : `${slot}.main`;
        return (
          <Box
            key={slot}
            sx={{
              width: size,
              height: size,
              borderRadius: "50%",
              border: "1.5px solid",
              borderColor: taken ? ink : inverted ? ink : "text.muted",
              backgroundColor: taken ? ink : "transparent",
              opacity: taken || inverted ? 1 : 0.6,
            }}
          />
        );
      })}
    </Box>
  );
}
